/** 将组件挂载到body下 */
import { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
const Popup = /*#__PURE__*/memo(({
  children
}) => {
  const [container, setContainer] = useState();
  useEffect(() => {
    const ctr = document.createElement('div');
    document.body.appendChild(ctr);
    setContainer(ctr);
    return () => {
      document.body.removeChild(ctr);
    };
  }, []);
  return container ? /*#__PURE__*/createPortal(children, container) : null;
});
Popup.displayName = 'cc-popup';
export default Popup;